import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ShieldAlert } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function AfgiftsfriBanner() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <section className="bg-slate-50 text-[#293e30] py-12 relative overflow-hidden border-y border-slate-200/60">
      {/* Decorative background grid */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#cbd5e1_1px,transparent_1px)] [background-size:16px_16px]"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          
          {/* Left side: Text content */}
          <div className="space-y-3 max-w-3xl">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-black italic uppercase tracking-tight leading-tight text-[#293e30]">
              {t('banner.title')}
            </h2>
            <p className="text-slate-600 text-xs sm:text-sm leading-relaxed">
              {t('banner.desc')}
            </p>
          </div>

          {/* Right side: Action Button */}
          <div className="shrink-0">
            <button
              onClick={() => {
                navigate('/saelg-din-bil');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#76eeda] hover:bg-[#5cdbc7] text-black font-bold text-sm tracking-wider uppercase rounded-none transition-all cursor-pointer"
            >
              {t('banner.cta')}
              <ArrowRight className="h-4 w-4 shrink-0" />
            </button>
          </div>

        </div>
      </div>
    </section>
  );
}
